/*jslint node: true, browser: true*/
"use strict";

var ko = require("pli/knockout");
var numberUtil = require("pli/util/number");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var formattedBehaviour = require("../ko-behaviours-formatted");
var entityRegistry = require("../entity-registry");
var viewModelInit = require("./viewModelInitExtensions");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function extractNumber(record, name) {
    var value = record && record[name];
    return (numberUtil.isNumber(value) ? value : null);
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ContactPercentage class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function ContactPercentage(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("ContactPercentage.ctor", factories); }

    this.guid = ko.observable(null);
    this.contact = this.id = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "required", "picklist");
    this.silent = ko.observable(false);
    this.contactInNetCalcs = ko.observable(false);
    this.percentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "required", "numeric", formattedBehaviour);

    // non-serialized properties
    this.extras = function ContactPercentageExtras() { return; };
    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
    this.extras.rental = ko.observable(null);
    this.extras.codeAndFullName = ko.observable(null);
    this.extras._subscriptionUpdateInfo = null;
    if (ko.isObservable(this.id.item)) {
        this.extras._subscriptionUpdateInfo = this.id.item.subscribe(this._updateInfo, this);
        this._updateInfo(this.id.item()); // force initial update
    }

    this.extras.rental.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.rental(), 'C2');
    }, this);
}


//---------------------------------------
ContactPercentage.prototype.applyServerCalculationResult = function applyContactPercentageResult(context) {
    var record = context.currentData;
    this.extras.rental(extractNumber(record, "rental"));
};


//---------------------------------------
ContactPercentage.prototype.buildServerCalculationData = function buildContactPercentageData() {
    return {
        contact: this.contact(),
        silent: this.silent(),
        contactInNetCalcs: this.contactInNetCalcs(),
        percentage: this.percentage()
    };
};


//---------------------------------------
ContactPercentage.prototype.initGridArray = function initContactPercentageGridArray(gridArray) {
    /// <summary>
    /// Add extra methods to the specified
    /// contact percentages grid array (that has just
    /// been created).
    /// </summary>
    gridArray.isReadOnly = ko.observable();
    gridArray.applyServerCalculationResult = ContactPercentage.prototype._applyResultToGridArray;
    gridArray.ownerPercentage = ko.observable(null);
    gridArray.totalPercentage = (gridArray.factory.factories.calculateTotalPercentageOnClient
        ? ko.computed(ContactPercentage.prototype._computeTotalPercentage, gridArray)
        : ko.observable(null));
    gridArray.totalPercentage.invalid = ko.computed(ContactPercentage.prototype._computeTotalPercentageInvalid, gridArray.totalPercentage);
    gridArray.totalRental = ko.observable(null);

    gridArray.totalRental.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(gridArray.totalRental(), 'C2');
    }, gridArray);

    gridArray.totalPercentage.precision = ko.pureComputed(function () {
        return numberUtil.formatNumber(gridArray.totalPercentage(), pli.config.editorPrecisionPercentFormat);
    }, gridArray);

    gridArray._originalDispose = gridArray.dispose;
    gridArray.dispose = ContactPercentage.prototype._disposeGridArray;

    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, gridArray.isReadOnly);
    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray, gridArray.isReadOnly);
    if (gridArray.factory.factories.copyItems) {
        gridArray.copyItems = gridArray.factory.factories.secureAction(gridArray.factory.factories.copyItems, gridArray);
    }
};


//-------------------------------------------
ContactPercentage.prototype.loadViewModel = function loadContactPercentage(record) {
    /// <summary>
    /// Populate viewmodel with data.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("ContactPercentage.loadViewModel", record); }

    if (!record) { record = {}; }

    this.contact.load(record.contact);
    this.guid(record.guid || null);
    this.percentage.load(record.percentage);

    if (typeof record.silent === "string") {
        this.silent(record.silent === "Yes");
    } else {
        this.silent(!!record.silent);
    }
    this.contactInNetCalcs(!!record.contactInNetCalcs);
};


//---------------------------------------
ContactPercentage.prototype._applyResultToGridArray = function contactPercentageApplyResultToCollection(context) {
    if (ko.isObservable(this.ownerPercentage)) {
        this.ownerPercentage(extractNumber(context.currentData, context.currentCollectionName + "OwnerPercentage"));
    }
    if (ko.isObservable(this.totalPercentage)) {
        this.totalPercentage(extractNumber(context.currentData, context.currentCollectionName + "TotalPercentage"));
    }
    if (ko.isObservable(this.totalRental)) {
        this.totalRental(extractNumber(context.currentData, context.currentCollectionName + "TotalRental"));
    }
};


//---------------------------------------
ContactPercentage.prototype._computeTotalPercentage = function computeTotalPercentage() {
    /// <summary>
    /// Sum all percentages in this grid array.
    /// This method is only used if this grid array
    /// was created with calculateTotalPercentageOnClient
    /// flag set to true.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid array.
    /// </remarks>
    var i, l, t = 0, a = this(), precision = pli.config.editorPrecision || 5;
    for (i = 0, l = a.length; i < l; i += 1) {
        // Round contact percentage by editor precision before adding to the total
        t += Math.round(a[i].percentage() * Math.pow(10, precision)) / Math.pow(10, precision);
    }
    return t;
};


//---------------------------------------
ContactPercentage.prototype._computeTotalPercentageInvalid = function computeTotalPercentageInvalid() {
    var totalPercentage = this();

    // Calculate the delta used for javascript floating point precision problem
    // using the decimal precision settings
    // http://stackoverflow.com/questions/588004/is-floating-point-math-broken
    var precision = pli.config.editorPrecision || 5;
    var delta = Math.pow(10, -(precision + 1));

    return (totalPercentage !== null && totalPercentage < 100 && Math.abs(100 - totalPercentage) > delta);
};


//---------------------------------------
ContactPercentage.prototype._disposeGridArray = function disposeGridArray() {
    /// <summary>
    /// This method is only used if this grid array
    /// was created with calculateTotalPercentageOnClient
    /// flag set to true.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid array.
    /// </remarks>
    this.totalPercentage.invalid.dispose();
    if (this.totalPercentage.dispose) { this.totalPercentage.dispose(); }
    this._originalDispose();
};

//---------------------------------------
ContactPercentage.prototype._updateInfo = function updateRelatedContactInfo(contactRow) {
    /// <remarks>
    /// Assumes "this" points to a related contact.
    /// </remarks>

    if (!contactRow) {
        this.extras.codeAndFullName(null);
        return;
    }

    var code = contactRow[0],
        fullName = contactRow[2];

    if (fullName && fullName.length > 0 && fullName !== " " && fullName !== code) {
        this.extras.codeAndFullName(code + " (" + fullName + ")");
    } else {
        this.extras.codeAndFullName(code);
    }
};


//-------------------------------------------
ContactPercentage.prototype.itemComparer = null; // disable client-side sorting


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = function createContactPercentageFactory(rootId, itemAccessor, calculateTotalPercentageOnClient, copyItems) {
    var factoryCreator = viewModelInit.standardFactoryCreatorFor(
        ContactPercentage,
        itemAccessor,
        function createExtraContactPercentageFactories() {
            return {
                calculateTotalPercentageOnClient: !!calculateTotalPercentageOnClient,
                copyItems: copyItems
            };
        }
    );
    return factoryCreator(rootId);
};



//////////////////
// WEBPACK FOOTER
// ./app/document/contactPercentageViewModel.js
// module id = 544
// module chunks = 49